(function () {
  function initWall(root) {
    if (!root || root.dataset.lwInit === '1') return;
    root.dataset.lwInit = '1';

  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function ratioOf(s) {
    if (!s) return 0.8;
    var p = String(s).split('/');
    if (p.length < 2) { var only = num(p[0], 0); return only > 0 ? only : 0.8; }
    var w = num(p[0], 4), h = num(p[1], 5);
    return h > 0 ? w / h : 0.8;
  }

  var tiles = [].slice.call(root.children);

  function layout() {
    var W = root.clientWidth;
    if (!W) return;
    var vw = window.innerWidth;
    var cols = vw <= 749 ? +root.dataset.colsM : (vw <= 1100 ? +root.dataset.colsT : +root.dataset.colsD);
    var gap = vw <= 749 ? +root.dataset.gapM : +root.dataset.gap;
    cols = Math.max(1, cols || 1);
    var colW = (W - gap * (cols - 1)) / cols;
    var stretch = (+root.dataset.stretch || 0) / 100;
    // how far a tile may ever be pushed from the shape you set: scales with the Gap filling setting
    var forcedCap = 1 + stretch * 1.7;
    var freeCap = 1 + stretch * 2.7;

    root.classList.add('is-packed');

    var src = [];
    tiles.forEach(function (t) {
      if (vw <= 749 && t.dataset.hideM === '1') { t.style.display = 'none'; return; }
      t.style.display = '';
      var span = vw <= 749 ? +t.dataset.spanM : +t.dataset.span;
      span = Math.max(1, Math.min(cols, span || 1));
      var w = span * colW + (span - 1) * gap;
      var r = ratioOf(vw <= 749 ? (t.dataset.ratioM || t.dataset.ratio) : t.dataset.ratio);
      var h;
      if (t.dataset.auto === '1') {
        t.style.width = w + 'px';
        t.style.height = 'auto';
        h = t.offsetHeight;
      } else {
        h = w / r;
      }
      var pinned = vw > 749;
      src.push({ el: t, span: span, w: w, h: h, r: r, h0: h, lock: pinned && t.dataset.lock === '1',
        newRow: pinned && t.dataset.newrow === '1', startCol: pinned ? (+t.dataset.startcol || 0) : 0 });
    });

    // justified rows: each row is filled left to right and scaled to the exact width,
    // so widths follow each photo's own shape and no gap is ever left
    if (root.dataset.mode === 'rows') {
      var target = colW * ((+root.dataset.rowh || 130) / 100);
      var i = 0, y = 0;
      while (i < src.length) {
        var row = [], sum = 0, hh = 0;
        while (i < src.length) {
          var it = src[i];
          if (row.length && it.newRow) break;
          row.push(it); sum += it.r; i++;
          hh = (W - gap * (row.length - 1)) / sum;
          if (hh <= target) break;
        }
        hh = (W - gap * (row.length - 1)) / sum;
        var lastRow = i >= src.length;
        if (lastRow && hh > target * 1.5) hh = target;
        var x = 0;
        for (var k = 0; k < row.length; k++) {
          var w = row[k].r * hh;
          if (!lastRow && k === row.length - 1) w = W - x;
          row[k].el.style.left = x + 'px';
          row[k].el.style.top = y + 'px';
          row[k].el.style.width = w + 'px';
          row[k].el.style.height = hh + 'px';
          x += w + gap;
        }
        y += hh + gap;
      }
      root.style.height = Math.max(0, y - gap) + 'px';
      return;
    }

    function build(out) {
      var ce = [], i;
      for (i = 0; i < cols; i++) ce.push([]);
      out.forEach(function (p) { for (var c = p.x; c < p.x + p.it.span; c++) ce[c].push(p); });
      ce.forEach(function (a) { a.sort(function (m, n) { return m.y - n.y; }); });
      return ce;
    }

    // grow tiles down into any hole, then close the bottom edge
    function closeHoles(out) {
      var pass, ce, changed, widened, c, a, i, A, B, hole, k, col, j, nx, room, ok, pushes = 0;
      for (pass = 0; pass < 60; pass++) {
        var forced = pass >= 4;      // ignore the soft stretch limit
        var free = pass >= 10;       // reshape the tile as far as the gap needs
        var push = pass >= 18;       // make room by sliding the column below down
        var last = pass >= 24;       // very last resort: let one tile bend further to kill a leftover gap
        ce = build(out); changed = false; widened = false;

        // move a tile and everything under it (in its own columns) further down
        function pushChain(seeds) {
          var mp = [], dl = [], q = seeds.slice(), qi = 0, e, ix, cq, lst2, k2, z;
          while (qi < q.length && qi < 4000) {
            e = q[qi++];
            ix = mp.indexOf(e.t);
            if (ix >= 0) { if (e.d <= dl[ix] + 0.01) continue; dl[ix] = e.d; }
            else { mp.push(e.t); dl.push(e.d); }
            for (cq = e.t.x; cq < e.t.x + e.t.it.span; cq++) {
              lst2 = ce[cq]; k2 = lst2.indexOf(e.t);
              if (k2 < 0) continue;
              for (z = k2 + 1; z < lst2.length; z++) q.push({ t: lst2[z], d: e.d });
            }
          }
          for (ix = 0; ix < mp.length; ix++) mp[ix].y += dl[ix];
          return mp.length > 0;
        }
        for (c = 0; c < cols; c++) {
          a = ce[c];
          for (i = 0; i + 1 < a.length; i++) {
            A = a[i]; B = a[i + 1];
            hole = B.y - (A.y + A.it.h + gap);  // recomputed each pass
            if (hole <= 0.5) continue;
            if (A.it.lock) continue;
            // how far the tile above can grow before it would touch anything below it
            room = Infinity; ok = true;
            for (k = A.x; k < A.x + A.it.span; k++) {
              col = ce[k]; j = col.indexOf(A);
              if (j < 0) { ok = false; break; }
              nx = col[j + 1];
              room = Math.min(room, nx ? nx.y - (A.y + A.it.h + gap) : Infinity);
            }
            if (ok && room > 0.5) {
              var cap = last ? freeCap * 1.4 : (free ? freeCap : forcedCap);
              var ceiling = A.it.h0 * cap - A.it.h;
              var room2 = forced ? ceiling : Math.min(ceiling, A.it.h0 * (1 + stretch) - A.it.h);
              var grow = Math.min(hole, room, room2);
              if (grow > 0.5) { A.it.h += grow; changed = true; hole -= grow; }
            }
            if (forced && hole > 0.5) {
              // a tile sitting alone beside an empty strip simply widens into it
              var side, T, tj, okw, safe, sl, sj, S;
              for (side = 0; side < 2 && !widened; side++) {
                var nc = side === 0 ? c - 1 : c + 1;
                if (nc < 0 || nc >= cols) continue;
                var lst = ce[nc];
                for (tj = 0; tj < lst.length; tj++) {
                  T = lst[tj];
                  if (T.it.lock) continue;
                  if (T.it.wid) continue;                          // widen a tile once only
                  if (T.y < A.y + A.it.h - 1) continue;            // above the hole
                  if (T.y + T.it.h > B.y + gap + 1) continue;      // below the hole
                  okw = side === 0 ? (T.x + T.it.span === c) : (T.x === c + 1);
                  if (!okw) continue;
                  if (T.it.span + 1 > cols) continue;
                  // the column it moves into must be free for the tile's whole height
                  safe = true; sl = ce[c];
                  for (sj = 0; sj < sl.length; sj++) {
                    S = sl[sj];
                    if (S === T) continue;
                    if (S.y + S.it.h <= T.y + 0.5) continue;
                    if (S.y >= T.y + T.it.h - 0.5) continue;
                    safe = false; break;
                  }
                  if (!safe) continue;
                  if (side === 1) { T.x -= 1; T.it.widLeft = true; }
                  T.it.span += 1;
                  T.it.wid = 1;
                  T.it.w = T.it.span * colW + (T.it.span - 1) * gap;
                  changed = true; widened = true;
                  break;
                }
              }
              if (widened) break;   // spans changed: rebuild the column map before doing anything else
            }
            if (forced && hole > 0.5) {
              // nothing above can stretch far enough: slide the tile below upwards instead
              var allowed = Infinity, kk, cc, jj, pv;
              for (kk = B.x; kk < B.x + B.it.span; kk++) {
                cc = ce[kk]; jj = cc.indexOf(B);
                if (jj < 0) { allowed = 0; break; }
                pv = cc[jj - 1];
                allowed = Math.min(allowed, pv ? B.y - (pv.y + pv.it.h + gap) : B.y);
              }
              var move = Math.min(hole, allowed);
              if (move > 0.5) { B.y -= move; changed = true; hole -= move; }
            }
            if (push && hole > 2 && pushes < 8) {
              // nothing else worked: slide whatever blocks the tile above further down,
              // then grow the tile into the gap. The wall gets taller, the hole disappears.
              var need = Math.min(hole, A.it.h0 * freeCap * 1.4 - A.it.h);
              if (need > 2) {
                var seeds = [], kb, cb, jb, nb, rb;
                for (kb = A.x; kb < A.x + A.it.span; kb++) {
                  cb = ce[kb]; jb = cb.indexOf(A);
                  if (jb < 0) continue;
                  nb = cb[jb + 1];
                  if (!nb) continue;
                  rb = nb.y - (A.y + A.it.h + gap);
                  if (rb < need - 0.5) seeds.push({ t: nb, d: need - rb });
                }
                if (seeds.length) {
                  pushChain(seeds);
                  A.it.h += need;
                  pushes++;
                  changed = true; widened = true;   // reuse the rebuild flag
                  break;
                }
              }
            }
          }
          if (widened) break;
        }
        if (!changed && last) break;
      }

      // safety net: no tile may ever overlap another
      (function () {
        function hit(p, q) {
          return p.x < q.x + q.it.span && q.x < p.x + p.it.span &&
                 p.y < q.y + q.it.h - 0.5 && q.y < p.y + p.it.h - 0.5;
        }
        var g, u, v, P, Q, up, lo;
        for (g = 0; g < 6; g++) {
          var bad = false;
          for (u = 0; u < out.length; u++) {
            for (v = u + 1; v < out.length; v++) {
              P = out[u]; Q = out[v];
              if (!hit(P, Q)) continue;
              bad = true;
              // first choice: undo a widening that caused it
              var vic = P.it.wid ? P : (Q.it.wid ? Q : null);
              if (vic) {
                if (vic.it.widLeft) { vic.x += 1; vic.it.widLeft = false; }
                vic.it.span -= 1;
                vic.it.wid = 0;
                vic.it.w = vic.it.span * colW + (vic.it.span - 1) * gap;
                continue;
              }
              // otherwise trim the upper tile so it stops above the lower one
              up = P.y <= Q.y ? P : Q;
              lo = up === P ? Q : P;
              up.it.h = Math.max(8, lo.y - gap - up.y);
            }
          }
          if (!bad) break;
        }
      })();

      // a column that simply runs out of tiles: widen the bottom tile beside it across
      var tp, tc, tH, tail, tj2, TT, freeCol, sj2, SS, bestT, bestB;
      for (tp = 0; tp < 6; tp++) {
        ce = build(out); tH = 0;
        ce.forEach(function (a) { if (a.length) { var l = a[a.length - 1]; tH = Math.max(tH, l.y + l.it.h); } });
        var fixed = false;
        for (tc = 0; tc < cols; tc++) {
          var lastT = ce[tc].length ? ce[tc][ce[tc].length - 1] : null;
          tail = lastT ? tH - (lastT.y + lastT.it.h) : tH;
          if (tail < colW * 0.25) continue;
          bestT = null; bestB = -1;
          for (var sd = 0; sd < 2; sd++) {
            var ncc = sd === 0 ? tc - 1 : tc + 1;
            if (ncc < 0 || ncc >= cols) continue;
            for (tj2 = 0; tj2 < ce[ncc].length; tj2++) {
              TT = ce[ncc][tj2];
              if (TT.it.lock) continue;
              if (TT.it.span + 1 > cols) continue;
              if (sd === 0 ? (TT.x + TT.it.span !== tc) : (TT.x !== tc + 1)) continue;
              var colEnd = lastT ? lastT.y + lastT.it.h : 0;
              if (TT.y + TT.it.h <= colEnd + 1) continue;
              if (TT.y > colEnd + gap + 1) continue;   // it must carry on from where the column stopped
              freeCol = true;
              for (sj2 = 0; sj2 < ce[tc].length; sj2++) {
                SS = ce[tc][sj2];
                if (SS.y + SS.it.h <= TT.y + 0.5) continue;
                if (SS.y >= TT.y + TT.it.h - 0.5) continue;
                freeCol = false; break;
              }
              if (!freeCol) continue;
              if (TT.y + TT.it.h > bestB) { bestB = TT.y + TT.it.h; bestT = { t: TT, side: sd }; }
            }
          }
          if (bestT) {
            if (bestT.side === 1) bestT.t.x -= 1;
            bestT.t.it.span += 1;
            bestT.t.it.w = bestT.t.it.span * colW + (bestT.t.it.span - 1) * gap;
            fixed = true;
            break;
          }
        }
        if (!fixed) break;
      }

      ce = build(out);
      var H = 0;
      ce.forEach(function (a) { if (a.length) { var l = a[a.length - 1]; H = Math.max(H, l.y + l.it.h); } });
      var done = [];
      ce.forEach(function (a) {
        if (!a.length) return;
        var l = a[a.length - 1];
        if (done.indexOf(l) >= 0) return;
        done.push(l);
        if (l.it.lock) return;
        var room = Infinity, k, col, j, nx;
        for (k = l.x; k < l.x + l.it.span; k++) {
          col = ce[k]; j = col.indexOf(l); nx = col[j + 1];
          room = Math.min(room, nx ? nx.y - (l.y + l.it.h + gap) : Infinity);
        }
        var d = Math.min(room, H - (l.y + l.it.h), l.it.h0 * (freeCap * 1.5) - l.it.h);
        if (d > 0.5) l.it.h += d;
      });
      // flat bottom without distorting a tile: clip the wall to the shortest column,
      // but never clip so high that a tile is lost or mostly cut off
      var ce2 = build(out), minB = Infinity;
      ce2.forEach(function (a) { if (a.length) { var l = a[a.length - 1]; minB = Math.min(minB, l.y + l.it.h); } });
      if (!isFinite(minB)) return H;
      var lost = false;
      out.forEach(function (p) {
        if (Math.min(p.y + p.it.h, minB) - p.y < p.it.h - 1) lost = true;
      });
      return lost ? H : minB;
    }

    function solve(lookAhead, eager) {
      var h = [], out = [], i;
      for (i = 0; i < cols; i++) h.push(0);
      var pend = src.map(function (o) { return { el: o.el, span: o.span, w: o.w, h: o.h, r: o.r, h0: o.h0, lock: o.lock, newRow: o.newRow, startCol: o.startCol, span0: o.span }; });
      while (pend.length) {
        var idx = 0, starve = 0, runN = 0;
        if (lookAhead) {
          var minY = Math.min.apply(null, h), maxY = Math.max.apply(null, h), c0 = 0, run = 0, k, found = -1;
          for (k = 0; k < cols; k++) { if (h[k] <= minY + 1) { c0 = k; break; } }
          for (k = c0; k < cols && h[k] <= minY + 1; k++) run++;
          for (var j = 0; j < Math.min(eager ? 16 : 10, pend.length); j++) {
            if (pend[j].newRow || pend[j].startCol) break;
            if (pend[j].span <= run) { found = j; break; }
          }
          if (found >= 0) idx = found;
          // nothing fits the starved strip: narrow the next tile so the strip gets filled
          else if (maxY - minY > colW * (eager ? 0.2 : 0.75) && run < cols && pend[0] && !pend[0].newRow && !pend[0].startCol && !pend[0].lock) {
            starve = run; runN = run;
          }
        }
        var it = pend.splice(idx, 1)[0];
        // narrow at most one column, so a tile you set wide stays wide
        if (starve && it.span > starve) {
          var ns = Math.max(starve, it.span - 1);
          if (ns < it.span) { it.span = ns; it.w = ns * colW + (ns - 1) * gap; it.h = it.w / it.r; it.h0 = it.h; }
        }
        var best = 0, bestY = 0, bestScore = Infinity, m;
        if (it.newRow || it.startCol) {
          best = it.startCol ? Math.min(it.startCol - 1, cols - it.span) : 0;
          if (best < 0) best = 0;
          bestY = 0;
          if (it.newRow) {
            for (m = 0; m < cols; m++) if (h[m] > bestY) bestY = h[m];
          } else {
            for (m = best; m < best + it.span; m++) if (h[m] > bestY) bestY = h[m];
          }
        } else {
          for (var c = 0; c + it.span <= cols; c++) {
            var y = 0, waste = 0;
            for (m = c; m < c + it.span; m++) if (h[m] > y) y = h[m];
            for (m = c; m < c + it.span; m++) waste += y - h[m];
            var score = y + waste;
            if (score < bestScore - 0.5) { bestScore = score; bestY = y; best = c; }
          }
        }
        out.push({ it: it, x: best, y: bestY });
        for (var n = best; n < best + it.span; n++) h[n] = bestY + it.h + gap;
      }
      var Ht = closeHoles(out);
      // measure the empty area that is still visible, so the better packing wins
      var mce = build(out), empty = 0;
      mce.forEach(function (col) {
        var cy = 0, q;
        for (q = 0; q < col.length; q++) {
          var t = col[q];
          if (t.y > cy + 1) empty += (Math.min(t.y, Ht) - cy) * colW;
          cy = Math.max(cy, t.y + t.it.h);
          if (cy >= Ht) break;
        }
        if (cy < Ht) empty += (Ht - cy) * colW;
      });
      // and measure how far it bends the shapes and widths you actually chose
      var warp = 0;
      out.forEach(function (p) {
        if (p.y >= Ht) return;
        var ideal = p.it.w / p.it.r;
        warp += Math.abs(p.it.h - ideal) * p.it.w;
        if (p.it.span !== p.it.span0) warp += Math.abs(p.it.span - p.it.span0) * colW * p.it.h * 0.8;
      });
      return { out: out, H: Ht, empty: empty, cost: empty + warp };
    }

    var tries = [solve(false, false), solve(true, false), solve(true, true)], win = tries[0], ti;
    for (ti = 1; ti < tries.length; ti++) {
      var cand = tries[ti];
      if (cand.cost < win.cost * 0.98) win = cand;
      else if (win.cost < cand.cost * 0.98) continue;
      else if (cand.H > win.H) win = cand;
    }

    win.out.forEach(function (p) {
      p.it.el.style.left = (p.x * (colW + gap)) + 'px';
      p.it.el.style.top = p.y + 'px';
      p.it.el.style.width = p.it.w + 'px';
      p.it.el.style.height = p.it.h + 'px';
    });
    root.style.height = Math.max(0, win.H) + 'px';
  }

  var raf;
  function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(layout); }

  layout();
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  root.querySelectorAll('img').forEach(function (im) {
    if (!im.complete) im.addEventListener('load', schedule, { once: true });
  });
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(root);

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);

  var vids = root.querySelectorAll('video');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.lwReady) {
            v.dataset.lwReady = '1';
            if (v.dataset.lwSrc) v.src = v.dataset.lwSrc;
            v.preload = 'auto';
            v.load();
          }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
  }
  }

  function scan() {
    var list = document.querySelectorAll('.lw[data-cols-d]');
    for (var i = 0; i < list.length; i++) initWall(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();